import { mapState, mapActions } from 'vuex'
import { Constants } from '../../constants'

export default {
    name: 'Alert',

    computed: {
        ...mapState(['alertCode', 'alertMessage']),

        showAlert() {
            if (this.alertCode > 0) {
                setTimeout(() => {
                    this.removeAlert()
                }, Constants.ALERT_TIMEOUT);
                return true
            }
            return false
        },

        isOk() {
            return this.alertCode >= 200 && this.alertCode < 300
        },

        isError() {
            return this.alertCode >= 400 && this.alertCode < 500
        },

        alertClass() {
            if (this.isOk) {
                return 'alert-status-ok'
            }else if (this.isError) {
                return 'alert-status-error'
            }
            return 'alert-status-error'
        }
    },

    methods: {
        ...mapActions([Constants.STORE_ACTION_RESET_ALERT]),

        doReset() {
            this.removeAlert()
        }
    }
}